/*  ONCE DOM IS READY - BUT IMAGES MAY NOT ALL BE LOADED  */
$(document).ready(function($) {

	$('#categorymobiletoggle').on( "click", function() {
  		$('#categorynav ul').toggle();
	});
  
    /* When window is resized, do some thangs */
    window.onresize = function(){

        /* Make sure category nav is visible if window is resized from xs to larger, and hidden if made smaller */
        if($(window).width() >= 768)
        {
            $('#categorynav ul').show();
        } else {
            $('#categorynav ul').hide();
        }

    }
  

});                  
                  
/*  ONLY AFTER ALL IMAGES ARE LOADED  */
$(window).load(function() {
                                   
  // vertically align all product thumbnails on the collection and product detail pages within their parent div, then reveal them
  $('.vcenter').vAlign();
  $('.vcenter').show();

  // Add the "active" class to the first carousel slide
  $('.carousel-inner .item').filter(":first").addClass('active');
  
  // If there's only one slide, hide the prev/next buttons
  var slideCount = $('.carousel-inner .item').size();
  if ( slideCount == 1 ) {
	$('.carousel-control').hide(); 
  }
  
  // Start the carousel
  $('.carousel').carousel();
  
  setProductImageContainerDimensions();
  verticalCenterCarouselControls();
  
  /* When window is resized, do some things */
  window.onresize = function(){
	setProductImageContainerDimensions();
    verticalCenterCarouselControls();
  }
  
  
});


// Set height of main product image container equal to its width
function setProductImageContainerDimensions() {
  var cw = $('#product-mainimage-container').width();
  $('#product-mainimage-container').css({'height':cw+'px'});
  $('.vcenter').vAlign();
}

// Vertically center carousel controls
function verticalCenterCarouselControls() {
  
	$('.carousel-control').each(function() {
  		var containerHeight = $( this ).height();
      	var imageHeight = $( this ).find('img').height();
      	var imageTop = Math.floor( containerHeight / 2 ) - Math.floor( imageHeight / 2);
		$( this ).find('img').css('margin-top', imageTop+'px');
    });
 
}

     document.getElementById('submitButtonId').onmouseover = function() {
	 document.getElementById("searchInput").className = "show";
}